import React from 'react';
import { array, element, func, object, oneOfType, node, string, bool } from 'prop-types';
import ListSuggestionItem from '../../ListSuggestionItem';
import { Container, SuggestionTitle, ResultsSuggestionsContainer } from './autocomplete-container.styles';

const AutocompleteContainer = ({
  desktopMode,
  handleClickProduct,
  handleClickSuggest,
  products,
  productsSuggestions,
  suggestions,
  suggestionsPrefix,
  term
}) => {
  return /*#__PURE__*/React.createElement(Container, {
    desktopMode: desktopMode,
    isEmpty: Object.values(suggestions).length === 0 && Object.values(products).length === 0
  }, /*#__PURE__*/React.createElement(ResultsSuggestionsContainer, {
    isEmpty: Object.values(suggestions).length === 0 && Object.values(products).length === 0
  }, desktopMode && Object.values(suggestions).length > 0 && /*#__PURE__*/React.createElement(SuggestionTitle, {
    "data-testid": "suggestion-title"
  }, "sugest\xF5es de resultados"), /*#__PURE__*/React.createElement("ul", null, Object.values(suggestions).map(suggestion => /*#__PURE__*/React.createElement(ListSuggestionItem, {
    desktopMode: desktopMode,
    prefix: suggestionsPrefix,
    term: term,
    key: suggestion.count,
    item: suggestion,
    onSearchSubmit: e => handleClickSuggest(e, suggestion == null ? void 0 : suggestion.term, 'clickSuggestion')
  })))), desktopMode && productsSuggestions && Object.values(productsSuggestions).length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SuggestionTitle, {
    "data-testid": "suggestion-title"
  }, "sugest\xF5es de produtos"), /*#__PURE__*/React.createElement("ul", null, Object.values(productsSuggestions).map(productSuggestion => /*#__PURE__*/React.createElement(ListSuggestionItem, {
    desktopMode: desktopMode,
    term: term,
    key: productSuggestion.id,
    item: productSuggestion,
    borderBottom: true,
    onSearchSubmit: e => handleClickProduct(e, productSuggestion)
  })))));
};

process.env.NODE_ENV !== "production" ? AutocompleteContainer.propTypes = {
  autocompleteRef: oneOfType([object, func]),
  desktopMode: bool,
  handleClickProduct: func.isRequired,
  handleClickSuggest: func.isRequired,
  handleClose: func.isRequired,
  products: oneOfType([array, object, node]),
  productsSuggestions: oneOfType([array, object, node]).isRequired,
  suggestions: oneOfType([array, object, node]),
  suggestionsPrefix: oneOfType([string, element]),
  term: string
} : void 0;
AutocompleteContainer.defaultProps = {
  autocompleteRef: {},
  desktopMode: false,
  products: [],
  suggestions: [],
  suggestionsPrefix: '',
  term: ''
};
export default AutocompleteContainer;